import React, { useCallback, useEffect, useState } from "react";

import toast from "react-hot-toast";

const EditUserPopup = ({ onClose, userId }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [loading, setLoading] = useState("");
  const [users, setUsers] = useState({});

  const [roles, setRoles] = useState([]);

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleRoleChange = (e) => {
    setRoleId(e.target.value);
  };

  return (
    <div className="flex flex-col justify-center overflow-hidden absolute top-0 right-0 z-[1000] bg-white rounded-md shadow p-4">
      <div className="bg-white w-[350px] p-4">
        <div className="flex items-center justify-between">
          <h1 className="text-[20px] font-bold text-navy-blue">Edit User</h1>
          <button
            className="flex justify-center text-[#E71D36] bg-[#E71D36]/20 rounded-3xl w-[30px] h-[30px]"
            onClick={onClose}
          >
            x
          </button>
        </div>

        <div className="flex flex-col mt-8">
          <form>
            <div className="flex flex-col">
              <label htmlFor="first-name">Full Name</label>
              <input
                type="text"
                id="firstName"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                placeholder="John "
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="emailAddress"
                onChange={(e) => setEmailAddress(e.target.value)}
                value={emailAddress}
                placeholder="example@gmail.com"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
              />
            </div>

            <div className="flex flex-col mt-2">
              <label for="gender">Gender</label>
              <select
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                id="gender"
                name="gender"
                onChange={handleGenderChange}
              >
                <option value="" selected disabled hidden>
                  Select Gender
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="phone-no">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                onChange={(e) => setPhoneNumber(e.target.value)}
                value={phoneNumber}
                placeholder="08033045559"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="address">Designation Held</label>
              <input
                type="text"
                id="address"
                onChange={(e) => setAddress(e.target.value)}
                placeholder="2239  Anthony Villlage"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="user-role">User's Role</label>
              <select
                id="roleId"
                placeholder="Front Desk Officer"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={handleRoleChange}
              >
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="user-role">User's Permission</label>
              <select
                id="roleId"
                placeholder="Front Desk Officer"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={handleRoleChange}
              >
                <option value="">Select Permission</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-6">
              <button
                className="w-full h-[50px] bg-primary text-white text-base font-semibold rounded-md"
                type="submit"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUserPopup;
